/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "__barrel_optimize__?names=Box,Typography!=!@mui/material";
import Image from "next/image";
import Link from "next/link";
import { useParams } from "next/navigation";
import { useTranslation } from "../../../i18n/client";
import FacebookOutlineIcon from "./svgs/FacebookOutlineIcon";
import InstagramOutlineIcon from "./svgs/InstagramOutlineIcon";
import IonosTechPartnerLogo from "./svgs/IonosTechPartnerLogo";
const socialLinks = [
    {
        key: "facebook",
        href: "https://www.facebook.com/people/BillStorenet/61577695133847/",
        Icon: FacebookOutlineIcon
    },
    {
        key: "instagram",
        href: "https://www.instagram.com/billstore_net/",
        Icon: InstagramOutlineIcon
    }
];
const footerSection = [
    // {
    //     name: 'newsletter',
    //     links: [{ name: 'login', link: '/' }, { name: '', link: '/' }]
    // },
    // {
    //     name: 'aboutUs',
    //     links: [{ name: 'company', link: '/' }, { name: 'products', link: '/' }, { name: 'jobs', link: '/' }]
    // },
    {
        name: "legal",
        links: [
            {
                name: "imprint",
                link: "/legal"
            },
            {
                name: "privacyPolicy",
                link: "/privacy"
            },
            {
                name: "terms",
                link: "/terms"
            }
        ]
    }
];
export default function FooterXRechnung() {
    const params = useParams();
    const lng = typeof (params === null || params === void 0 ? void 0 : params.lng) === "string" ? params.lng : "en";
    const { t } = useTranslation(lng, "footer");
    const localizedLink = (link)=>"/".concat(lng).concat(link);
    return /*#__PURE__*/ _jsx(Box, {
        sx: {
            backgroundColor: "#DCE3FC",
            width: "100%"
        },
        children: /*#__PURE__*/ _jsxs(Box, {
            sx: {
                width: "100%",
                maxWidth: "1400px",
                margin: "0 auto",
                display: "flex",
                justifyContent: "space-between",
                flexWrap: "wrap",
                gap: 8,
                paddingY: 2.5,
                paddingX: "20px",
                "@media (min-width: 1024px)": {
                    paddingY: 4.5,
                    paddingX: 0
                }
            },
            children: [
                /*#__PURE__*/ _jsxs(Box, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            fontSize: 20,
                            fontWeight: 500,
                            paddingBottom: 1.5,
                            children: t("support")
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            fontSize: 14,
                            fontWeight: 500,
                            paddingBottom: 2.5,
                            children: "support@billstore.net"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            fontSize: 14,
                            fontWeight: 500,
                            children: t("24h")
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    sx: {
                        display: "flex",
                        gap: "60px",
                        flexWrap: "wrap"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(IonosTechPartnerLogo, {
                            height: 104,
                            width: 150
                        }),
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/assets/DSGVO.webp",
                            alt: "DSGVO Logo",
                            width: 150,
                            height: 104
                        }),
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/assets/c5.webp",
                            alt: "c5 Logo",
                            width: 104,
                            height: 104
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    sx: {
                        display: "flex",
                        gap: {
                            xs: 4,
                            sm: "60px"
                        },
                        flexWrap: "wrap",
                        justifyContent: "space-between",
                        "@media (min-width: 1024px)": {
                            gap: "60px"
                        }
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(Box, {
                            sx: {
                                display: "flex",
                                flexDirection: "column",
                                gap: 1.25
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Typography, {
                                    fontWeight: 700,
                                    fontSize: 16,
                                    children: t("followUs")
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    component: "nav",
                                    "aria-label": t("followUs"),
                                    sx: {
                                        display: "flex",
                                        gap: 2.5
                                    },
                                    children: socialLinks.map((param)=>{
                                        let { key, href, Icon } = param;
                                        return /*#__PURE__*/ _jsx(Box, {
                                            component: "a",
                                            href: href,
                                            target: "_blank",
                                            rel: "noopener noreferrer",
                                            "aria-label": t(key),
                                            sx: {
                                                display: "inline-flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                color: "#FF9F24",
                                                textDecoration: "none",
                                                flexShrink: 0,
                                                transition: "color 0.2s ease",
                                                "&:hover": {
                                                    color: "#F28C08"
                                                }
                                            },
                                            children: /*#__PURE__*/ _jsx(Icon, {
                                                size: 27
                                            })
                                        }, key);
                                    })
                                })
                            ]
                        }),
                        footerSection.map((section)=>/*#__PURE__*/ _jsxs(Box, {
                                sx: {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1.25
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Typography, {
                                        fontWeight: 700,
                                        fontSize: 16,
                                        children: t(section.name)
                                    }),
                                    section.links.map((link)=>/*#__PURE__*/ _jsx(Link, {
                                            style: {
                                                color: "inherit",
                                                textDecoration: "inherit"
                                            },
                                            href: localizedLink(link.link),
                                            children: /*#__PURE__*/ _jsx(Typography, {
                                                fontWeight: 500,
                                                sx: {
                                                    fontSize: "14px",
                                                    "@media (min-width: 1024px)": {
                                                        fontSize: "14px"
                                                    }
                                                },
                                                children: t(link.name)
                                            })
                                        }, link.name))
                                ]
                            }, section.name))
                    ]
                })
            ]
        })
    });
}
